/* eslint-disable */
// import Cookie from "js-cookie";
// import "isomorphic-fetch";
import _ from "lodash";
import { normalize } from "normalizr";
import { IS_PRD } from "./constants";
import * as Sentry from "@sentry/browser";

export const SERVER_TYPES = {
  MAIN: "api",
  ANALYTICS: "analytics",
  CALENDAR: "calendar",
};

const setCSRFToken = req => {
  // if (req.method === "GET") {
  //   return req;
  // }
  // const cookieName = "csrftoken";
  // const csrfToken = Cookie.get(cookieName);
  // if (csrfToken) {
  //   req.headers["X-CSRFTOKEN"] = csrfToken;
  // }
  return req;
};

const refreshToken = async () => {
  const token = localStorage.getItem("refresh_token");

  if (!token) { return };

  try {
    const { response } = await callApi(
      "totp/refresh/",
      {
        method: "POST",
        body: {
          "refresh": token,
        }
      },  
    )
    if (!response) return
    localStorage.setItem("access_token", response.access);
    localStorage.setItem("totp_token", response.access);
    localStorage.setItem("refresh_token", response.refresh);
  } catch (error) {
    console.log("failed to refresh token, ERR:", error)
    return false
  }
};

const { hostname } = window.location;

export const IS_DEV_ENVIRONMENT = !!window.Cypress || !window.localStorage.getItem("api_host") &&
  hostname.includes('poppins.live') &&
  !hostname.includes('clinic.poppins.live') &&
  !hostname.includes('training.poppins.live');

const TRAINING_API_DOMAIN = "training.poppins.live";
const STAGING_API_DOMAIN = ".poppins.live";
const PRODUCTION_API_DOMAIN = ".poppins.co.il";

const REGEX_DEV_DOMAINS = new RegExp("dev[0-9].poppins.live");

const TRAINING_CLIENT_HOST = "training.poppins.live";
const STAGING_CLIENT_HOST = "clinic.poppins.live";
const PRODUCTION_CLIENT_HOST = "clinic.poppins.co.il";
const POPINS_CLIENT_HOST = "clinic.poppins.co.il";

export const getAPIServerHost = (serverType = SERVER_TYPES.MAIN) => {
  const createApiDomain = (name, domain) => {
    if (domain.indexOf(".") === 0) {
      return `${name}${domain}`;
    }
    return `${name}-${domain}`;
  }

  const getPreferedAPIServer = (serverType = SERVER_TYPES.MAIN) => {
    let preferedDomain = PRODUCTION_CLIENT_HOST;
    if (hostname.includes(TRAINING_CLIENT_HOST)) {
      preferedDomain = TRAINING_API_DOMAIN;
    } else if (hostname.includes(STAGING_CLIENT_HOST)) {
      preferedDomain = STAGING_API_DOMAIN;
    } else if (hostname.includes(PRODUCTION_CLIENT_HOST)) {
      preferedDomain = PRODUCTION_API_DOMAIN;
    } else if (IS_DEV_ENVIRONMENT) {
      if (window.location.host.search(REGEX_DEV_DOMAINS) != -1) {
        preferedDomain = window.location.hostname;
      } else {
        preferedDomain = STAGING_API_DOMAIN;
      }
    }

    if (serverType === SERVER_TYPES.MAIN) {
      return createApiDomain(SERVER_TYPES.MAIN, preferedDomain);
    }

    if (serverType === SERVER_TYPES.ANALYTICS) {
      return createApiDomain(SERVER_TYPES.ANALYTICS, preferedDomain);
    }

    if (serverType === SERVER_TYPES.CALENDAR) {
      return createApiDomain(SERVER_TYPES.CALENDAR, preferedDomain);
    }


    if (serverType === SERVER_TYPES.RECORDINGS) {
      return createApiDomain(SERVER_TYPES.RECORDINGS, preferedDomain);
    }

    return `${hostname.replace(hostname.slice(0,hostname.indexOf(".")), serverType)}`;
  }

  try {
    if(IS_DEV_ENVIRONMENT && window.sessionStorage.getItem(`${serverType}_host`)) {
      return window.sessionStorage.getItem(`${serverType}_host`);
    }
    if(serverType === SERVER_TYPES.MAIN) {
      return IS_DEV_ENVIRONMENT && window.localStorage.getItem(window.location.hostname) || window.localStorage.getItem(`${serverType}_host`) || getPreferedAPIServer(serverType);
    }
  } catch (e) {
    console.error("Error fetching API Host")
  }
  return getPreferedAPIServer(serverType);
}

export const getLocalServerHost = (serverType = SERVER_TYPES.MAIN, isWS = false) => {
  try {
      if(window.sessionStorage.getItem(`${serverType}_host`)) {
        return `${isWS ? "ws" : "http"}s://${window.sessionStorage.getItem(`${serverType}_host`)}`;
      }
      if(window.localStorage.getItem(`${serverType}_host`)) {
        return `${isWS ? "ws" : "http"}s://${window.localStorage.getItem(`${serverType}_host`)}`;
      }
      if(serverType ===  SERVER_TYPES.MAIN) {
        return `${isWS ? "ws" : "http"}://localhost:8000`;
      }
      if(serverType ===  SERVER_TYPES.ANALYTICS) {
        return `${isWS ? "ws" : "http"}://localhost:5000`;
      }
      if(serverType === SERVER_TYPES.RECORDINGS) {
        return `${isWS ? "ws" : "http"}://localhost:8080`;
      }
      if(serverType ===  SERVER_TYPES.CALENDAR) {
        return `${isWS ? "ws" : "http"}://localhost:8002`;
      }
  } catch (e) {
    console.error("Error fetching API Host")
  }
  return "";
};
const localServerStatus = hostname === "localhost";
export let API_SERVER_URL = localServerStatus ? getLocalServerHost(SERVER_TYPES.MAIN) : `https://${getAPIServerHost()}`;
export let WS_API_SERVER_URL = localServerStatus ? getLocalServerHost(SERVER_TYPES.MAIN, true) : `wss://${getAPIServerHost()}`;

export let ANALYTICS_SERVER_URL = localServerStatus ? getLocalServerHost(SERVER_TYPES.ANALYTICS) : `https://${getAPIServerHost(SERVER_TYPES.ANALYTICS)}`;
export let RECORDINGS_SERVER_URL = localServerStatus ? getLocalServerHost(SERVER_TYPES.RECORDINGS) : `https://${getAPIServerHost(SERVER_TYPES.RECORDINGS)}`;
export let WS_RECORDINGS_SERVER_URL = localServerStatus ? getLocalServerHost(SERVER_TYPES.RECORDINGS, true) : `wss://${getAPIServerHost(SERVER_TYPES.RECORDINGS)}`;
//export let WS_RECORDINGS_SERVER_URL = localServerStatus ? "ws://localhost:8080" : `wss://${getAPIServerHost(SERVER_TYPES.RECORDINGS)}`;
export let CALENDAR_SERVER_URL = localServerStatus ? getLocalServerHost(SERVER_TYPES.CALENDAR) : `https://${getAPIServerHost(SERVER_TYPES.CALENDAR)}`;

/*
  This code is running on staging (poppins.live only.)
*/
if (IS_DEV_ENVIRONMENT) {
  (() => {
      // Checking that api_host is not defined
      // Checking that we are on Dev enviroment
      // Checking if Dev API is availible, if so, let's use it.
      const possibleHostForDev = `api-${window.location.host.replace(".poppins.live", "")}.poppins.live`;

      fetch(`https://${possibleHostForDev}/health/`).then(response => {
        if (response.ok) {
          return response.json().then(text => {
            if (text.healthcheck) {
              window.localStorage.setItem(window.location.hostname, possibleHostForDev);
              API_SERVER_URL = window.location.hostname === "localhost" ? "http://localhost:8000" : `https://${possibleHostForDev}`;
              WS_API_SERVER_URL = window.location.hostname === "localhost" ? "ws://localhost:8000" : `wss://${possibleHostForDev}`;
            }
          })
        }
      }).catch(() => {
        window.localStorage.removeItem(window.location.hostname);
        console.error(`API server not found under ${possibleHostForDev}`)
      })
    }
  )();
}

const checkHealthCheck = async (url) => {
  try {
    const response = await fetch(
      `${url}/health`,
      {mode: 'no-cors'}
  );
    response.ok && console.log(`${url}/health active`)
  } catch (e) {
    console.log(`${url}/health inactive`, e.message)
  }
}

checkHealthCheck(`${ANALYTICS_SERVER_URL}`);
checkHealthCheck(`${RECORDINGS_SERVER_URL}`);

setInterval(() => {
  refreshToken()
}, [1000 * 60])


const getApiUrlByType = (type) => {
  if(type ===  SERVER_TYPES.MAIN || !type) {
    return API_SERVER_URL;
  }
  if(type ===  SERVER_TYPES.ANALYTICS) {
    return ANALYTICS_SERVER_URL;
  }
  if(type === SERVER_TYPES.RECORDINGS) {
    return RECORDINGS_SERVER_URL
  }
  if(type === SERVER_TYPES.CALENDAR) {
    return CALENDAR_SERVER_URL;
  }
}

export const getApiEndpoint = (endpoint, options, serverTypes) => {
  let url;
  if (!endpoint) return "";
  const base_url = getApiUrlByType(serverTypes);

  if (endpoint.indexOf("http") !== -1) {
    url = new URL(endpoint);
  } else {
    url = new URL(`${base_url}/${endpoint}`);
  }

  // Making sure we add timestamp
  if (!options) {
    options = {};
  }

  if (!options.params) {
    options.params = {};
  }

  // TODO: Check if this is needed
  // options.params.timestamp = Date.now();

  Object.keys(options.params).forEach(key => url.searchParams.append(key, options.params[key]));
  return url.href;
};

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
export const callApi = (endpoint, options, schema, serverTypes = SERVER_TYPES.MAIN ) => {
  const url = getApiEndpoint(endpoint, options, serverTypes);
  let req = {
    headers: {},
    method: options && options.method ? options.method : "GET",
  };
  if (options.type === 'URL_ENCODED') {
    req = { ...req, withCredentials: true, credentials: 'include' };
  }
  if (options.apiType !== "game") {
    // req.credentials = "include";
  }
  const token = localStorage.getItem("access_token");
  if (token && options.apiType !== "game") {
    req = { ...req, headers: { Authorization: `JWT ${localStorage.getItem("access_token")}` } };
  }

  const codeToken = localStorage.getItem("code_login_token");
  if (codeToken) {
    req = { ...req, headers: { Authorization: `CODE ${codeToken}` } };
  }

  const classToken = localStorage.getItem("class_login_token");
  if (classToken) {
    req = { ...req, headers: { Authorization: `CLASS ${classToken}` } };
  }

  if (serverTypes === SERVER_TYPES.MAIN) { // TODO - add this to all servers. currently tested on juno-server only
    req.headers = { 
      ...req.headers, 
      "pragma": "no-cache",
      "cache-control": "no-cache",
    }
  }

  // Adding form data in case it's post
  if (options && options.body) {
    let data = [];
    if (options.type === 'URL_ENCODED') {
      req.body = Object.keys(options.body).map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(options.body[key])).join('&');
    } else {
      data = new FormData();
      for (const property in options.body) {
        if (options.body.hasOwnProperty(property)) {
          if (_.isArray(options.body[property])) {
            for (const x in options.body[property]) {
              data.append(property, x);
            }
          } else if (_.isObject(options.body[property])) {
            data.append(property, JSON.stringify(options.body[property]));
          } else {
            data.append(property, options.body[property]);
          }
        }
      }
      if (options.files) {
        for (const f of options.files) {
          data.append("files", f, f.name);
        }
      }
      req.body = ["JSON", "PDF"].includes(options.type) ? JSON.stringify(options.body) : data;
    }
  }

  // upload multiple files
  else if (options && options.files) {
    const upload = new FormData();
    for (const f of options.files) {
      upload.append("files", f, f.name);
    }

    req.body = upload;
  }

  if (options && ["JSON", "PDF"].includes(options.type)) {
    req.headers.Accept = "application/json";
    req.headers["Content-Type"] = "application/json";
  } else if (options && ["URL_ENCODED"].includes(options.type)) {
    req.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
  }

  if (options && options.type === "PDF") {
    return fetch(url, req).then(async (response) => {
      if (response.status === 401) {
        await clearLoginTokensAndReload();
        return Promise.reject(response);
      } else {
        if (response.status === 418) { // we're using 418 to mark "too many sql calls on server-side"
          !IS_PRD && window.alert("too many sql calls done on server");
          return response.blob();
        }
        if (!response.ok) {
          // might want to use response.ok
          return Promise.reject(response);
        }
        return response.blob();
      }
    });
  }

  req = setCSRFToken(req);
  return fetch(url, req).then(
    async (response) => {
      if (response.status === 401 && localStorage.getItem("totp_token")) {
        // await clearLoginTokensAndReload();
        return Promis.e.reject(response);
      } else {
        return response.text().then(data => {
          try {
            const json = JSON.parse(data);
            if (response.ok || response.status === 418) { // we're using 418 to mark "too many sql calls on server-side"
              response.status === 418 && !IS_PRD && window.alert("too many sql calls done on server");
              if (schema) {
                return { response: normalize(json, schema) };
              }
              return { response: json };
            }
            return Promise.reject({...json, name: response.status.toString()});
          } catch (err) {
            // It is text, do you text handling here
            if (!response.ok) {
              return Promise.reject({ message: err.message || "Something bad happened", name: response.status.toString() });
            }
            return { response: data };
          }
        });
      }
    },
    error => Promise.reject({ message: error.message || "Something bad happened" }),
  );
};

export const  clearLoginTokensAndReload = async () => {
  localStorage.removeItem("code_login_token");
  localStorage.removeItem("class_login_token");
  localStorage.removeItem("access_token");
  localStorage.removeItem("totp_token");
  window.location = "/login";
  window.location.reload()
  await sleep(10000); // let window.location do it's thing..
}

export const upload = (endpoint, file, options) => {
  const url = getApiEndpoint(endpoint);
  const formData = new FormData();

  formData.append("file", file);
  formData.set("filename", file.name);

  let req = {
    credentials: "include",
    headers: {},
    method: "POST",
    body: formData,
  };

  req = setCSRFToken(req);

  return fetch(url, req)
    .then(
      response => response.json(), // if the response is a JSON object
    )
    .catch(
      error => console.error(error), // Handle the error response object
    );
};

export const getCurrentBuildNumber = async () => {
  try {
    const cacheBuster = new Date().getTime();
    const res = await fetch(`/asset-manifest.json?v=${cacheBuster}`);
    const body = await res.text();
    // if (window.location.hostname === "localhost") {
    //   return new Date().getTime();
    // }
    return JSON.parse(body)?.["files"]?.["main.js"];
  } catch (e) {
    console.error("Failed to get current build");
  }
}
const urls = {
  API_SERVER_URL: {url: API_SERVER_URL.replace("http://", "").replace("https://", ""), storageKey: SERVER_TYPES.MAIN},
  RECORDINGS_SERVER_URL: {url: RECORDINGS_SERVER_URL.replace("http://", "").replace("https://", ""), storageKey: SERVER_TYPES.RECORDINGS},
  CALENDAR_SERVER_URL: {url: CALENDAR_SERVER_URL.replace("http://", "").replace("https://", ""), storageKey: SERVER_TYPES.CALENDAR},
}

sessionStorage.setItem("urls", JSON.stringify(urls)); // For the chrome extension that controls the servers urls
